
import React from "react";
import { AuthContext } from "../../auth/authProvider.jsx";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import makeStyles from '@mui/styles/makeStyles';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import { Redirect } from 'react-router-dom'
import IsometricMap from "../../components/IsometricMap/IsometricMap.js";
import { ReactComponent as AshLogo } from '../../assets/ashLogo.svg';
import GutermannLogo from '../../assets/gutermann/gutermnn-full-brand-white.png'
import { withStyles, createStyles } from '@mui/styles';
import CardFooter from '../../components/Card/CardFooter.js';
import BG from '../../assets/BG-Aquaguard.jpg';
import { CreateUrl } from 'Utils/ApiHelper.js';
import Footer from '../../components/Navbars/footer.tsx'
import { GB, DE, FR, PT, ES } from 'country-flag-icons/react/3x2'
import { injectIntl } from 'react-intl';
import { withTheme, Theme } from '@mui/styles';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { IsMobileContext } from '../../Context/ContextProvider'
import {entra } from '../../variables/identityUrl.js'


const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 345,
        backgroundColor: theme.palette.background.default,
    },
    media: {
        height: 140,
    },
}));
const styles = {
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontSize: 60,
        fontWeight: window.location.hostname.includes('zonelog.net') ? "500" : "100",
        fontFamily: window.location.hostname.includes('zonelog.net') ? "'Montserrat', 'Helvetica', 'Arial', sans-serif" : "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none"
    },
    cardCategoryWhite: {
        "&,& a,& a:hover,& a:focus": {
            color: "rgba(255,255,255,.62)",
            margin: "0 auto",
            fontSize: "14px",
            marginTop: "0",
            marginBottom: "0",
            textAlign: "center"
        },
        "& a,& a:hover,& a:focus": {
            color: "#FFFFFF"
        }
    },
};
const style = createStyles(styles);



export class LandingPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            forgotPassword: false,
            newRegister: false,
            enableSelfRegistration: false,
            systemMessage: ""
        }
        this.loginBtnRef = React.createRef(null)
    }
     
    componentDidMount() {
 
        const me = this;
        
        fetch(CreateUrl('/api/aquaguard/Version'), {})
            .then(async response => {
                if (response.ok) {
                    return response.json();
                }
            },
            // Reject
                () => {
                    window.sessionStorage.setItem("enableSelfRegistration", "false");
                }
            )
            .catch(function (error) {
                console.error(error);
            })
            .then(async data => {
                if (data && data.enableSelfRegistration) {
                    window.sessionStorage.setItem("enableSelfRegistration", data.enableSelfRegistration ? "true" : "false");
                    me.setState({ enableSelfRegistration: data.enableSelfRegistration });
                }
                else {
                    window.sessionStorage.setItem("enableSelfRegistration", "false");
                    me.setState({ enableSelfRegistration: false });
                }
            });

            fetch(CreateUrl('/api/aquaguard/GetSystemInfo'), {})
                .then(async response => {
                    if (response.ok) {
                        return response.json();
                    }
                })
                .catch(err => {
                    console.error(err)
                })
                .then(async data => {

                    if (data && data.length > 0) {

                        this.setState({ systemMessage: data[0].message })
                    } 
                   
                })
            

    }

    

    signOut = (authContextValue) => {
        authContextValue.signoutRedirect();
    }

    signIn = (authContextValue):void => {

        window.sessionStorage.setItem("unknownUser", "false");

        //logout if logged in
        if (authContextValue.isAuthenticated())
            authContextValue.logout();

        authContextValue.signinRedirect();

    }

    forgotPassword = () => {
        this.setState({ forgotPassword: true });
    }

    newRegister = () => {
        this.setState({ newRegister: true });
    }

    getFlagStyles = (lng) => {
        const isSelected = this.state.selectedLanguage === lng;
        const isHovered = this.state.hoveredLanguage === lng;
        return {
            fontSize: '32px',
            cursor: 'pointer',
            margin: '5px',
            transition: 'transform 0.3s ease',
            transform: isSelected || isHovered ? 'scale(1.2)' : 'scale(1)',
            border: isSelected ? '2px solid #EED202' : 'none',
            padding: isSelected ? '2px' : '0',
        };
    };

    handleSessionStorageReset = () => {
        sessionStorage.clear()
        if (this.loginBtnRef && this.loginBtnRef.current) {
            this.loginBtnRef.current.click()
        }
    }

    


    render() {

        const { classes, intl, theme } = this.props;

        return (
            <AuthContext.Consumer>
                {(authContextValue) => (
                    <IsMobileContext.Consumer>
                        {(mobileContextValue) => (
                    (!this.state.forgotPassword && !this.state.newRegister) ? //if forgot password - redirect to resetpassword page
                        (
                            <div style={{
                                backgroundImage: `url(${BG})`,
                                width: '100vw',
                                height: '100vh',
                                overflow: 'hidden',


                            }}>
                                {this.state.systemMessage &&
                                    <div style={{
                                        width: "100%",
                                        height:  'auto',
                                        background: theme.palette.primary.main,
                                        display: "flex",
                                        justifyContent: "center",
                                                position: mobileContextValue ? "fixed" : "relative",
                                        bottom: 0

                                    }}>
                                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: '2px', maxWidth: "80%", alignItems: 'center' }}>
                                            <WarningAmberIcon color='error' />
                                                    <p style={{ color: 'black', margin: mobileContextValue ? "0 20px" : "0 100px", textAlign: "center" }}><b>{this.state.systemMessage}</b></p>
                                            <WarningAmberIcon color='error' />
                                        </div>
                                    </div>}
                                <div className='some-page-wrapper'>
                                    <div>

                                        <div style={{ display: "flex", width: "100%", height: "100%", justifyContent: "center" }}>
                                            <div>

                                                <Card style={{
                                                    margin: mobileContextValue ? "3vw 0 3vw 0" : "3vw 0 0 0",
                                                    background: 'linear-gradient(130deg, rgba(0, 0, 0, 0.7) 0%, rgb(20,60,103, 0.6) 70%)',
                                                    width: mobileContextValue ? '90vw' : "30vw",
                                                    height: mobileContextValue ? "95vh": "80vh",
                                                    boxShadow: "2px 2px 10px black",
                                                            padding: mobileContextValue ? "0 0 0 0" : "5vh 0 0 0"

                                                }}>
                                                    <div>
                                                        <CardHeader className={'center'}>
                                                            {window.location.hostname.includes('zonelog.net') ? <img src={GutermannLogo} style={{ width: "90%", height: "90%", margin: "60px 0 20px 0" }} />
                                                                : <AshLogo />}
                                                            <h3 className={classes.cardTitleWhite}>{window.location.hostname.includes('zonelog.net') ? "ZONELOG" : "AquaGuard"}</h3>
                                                        </CardHeader>
                                                        <CardBody>
                                                            <div style={{ display: "flex", justifyContent: "space-around" }}>
                                                                        <Button
                                                                            ref={this.loginBtnRef }
                                                                    style={mobileContextValue ? {padding: "15px", width: "80%", fontSize: "22px"} : window.location.hostname.includes('zonelog.net') ? { width: "60%", marginTop: "30px", fontFamily: 'Montserrat', fontWeight: '600' } : { width: '80%' }}
                                                                    variant="contained"
                                                                    color="primary"
                                                                    onClick={() => this.signIn(authContextValue)}
                                                                >
                                                                    Login
                                                                </Button>
                                                            </div>
                                                            {window.sessionStorage.getItem("unknownUser") == 'true' &&
                                                                <div className={classes.cardCategoryWhite}>
                                                                    <h6>Unrecognised User on this Portal</h6>
                                                                </div>
                                                            }
                                                        </CardBody>
                                                        <CardFooter>
                                                            <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", width: "100%", marginTop: "30px" }}>
                                                                        {!entra && <div className={classes.cardCategoryWhite}>
                                                                            <a href="#" onClick={this.forgotPassword} style={{ textShadow: "0 0 2px black" }}><u>Forgot password?</u></a>
                                                                            {/*!window.location.hostname.includes('zonelog.net') && <p style={{ textShadow: "0 0 2px black", color: "white" }}>Not registered?<br /> Click <a href="#" onClick={this.newRegister}><u>here</u></a> to create an Account</p>*/}
                                                                        </div>}
                                                                        <div style={{ color: "white", marginTop: 20 }}><p style={{ textAlign: "center" }}>Having issues logging in?<br /><span style={{ textShadow: "0 0 2px black", textDecoration: "underline" }} onClick={() => this.handleSessionStorageReset()}>Click here</span> to clear {window.location.hostname.includes('zonelog.net') ? 'ZONELOG' : 'Aquaguard'} browser and login again</p> </div>
                                                            </div>
                                                        </CardFooter>
                                                    </div>
                                                </Card>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ position: "fixed", bottom: 0, width: "100%" }}>
                                        <Footer />
                                    </div>
                                </div>
                            </div>
                        )
                        :
                        (
                            this.state.forgotPassword ?
                                <Redirect to={'/forgotpassword'} />
                                :
                                <Redirect to={'/register'} />
                                ))}
                    </IsMobileContext.Consumer>)}
                </AuthContext.Consumer >
            )
    }
}

export default withTheme(withStyles(styles)(LandingPage));

